import React from 'react';
import Product from '../../Types/Product';

const ProductListingStructuredData = ({
  product,
}: {
  product: Product;
}) => {
  return (
    <>
      <div itemScope itemType="https://schema.org/Product" itemProp="item">
        <meta itemProp="name" content={product.name} />
        <meta itemProp="url" content={product.url} />
        <meta itemProp="description" content={product.description} />
        {product.images?.map((img, idx) => (
          <link
            itemProp="image"
            href={img.originalSrc}
            key={`${product.id}-meta-image-${idx}`}
          />
        ))}
        {product.price.price && (
          <div
            itemScope
            itemType="https://schema.org/Offer"
            itemProp="offers"
          >
            <meta
              itemProp="price"
              content={`${product.price.price.priceWithVat}`}
            />
            <meta
              itemProp="priceCurrency"
              content={product.price.currency.id}
            />
            {product.stockStatus?.inStock ? (
              <meta
                itemProp="availability"
                content="https://schema.org/InStock"
              />
            ) : (
              <meta
                itemProp="availability"
                content="https://schema.org/OutOfStock"
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ProductListingStructuredData;
